// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Calendar_wrapper__og-2T {
  background-size: cover;
  background-repeat: no-repeat;
  margin-top: 110px;
  padding-bottom: 80px;
}
.Calendar_wrapper__og-2T .Calendar_container__bjtjy {
  margin: 0 auto;
  width: 80%;
  padding-top: 30px;
}
.Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_header__GpjMU {
  align-items: center;
  border-bottom: 1px solid rgba(224, 224, 224, 0.3490196078);
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  padding-bottom: 31px;
  margin-bottom: 24px;
}
.Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_header__GpjMU .Calendar_month__9iVd8 {
  font-size: 24px;
  font-weight: 700;
  font-style: normal;
  align-items: center;
  color: #fff;
  display: flex;
  gap: 20px;
  justify-content: center;
}
.Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_header__GpjMU .Calendar_month__9iVd8 .Calendar_arrowWrapper__ukiXT {
  align-items: center;
  background-color: rgba(250, 249, 248, 0.2);
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  height: 32px;
  justify-content: center;
  width: 32px;
}
.Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_header__GpjMU .Calendar_month__9iVd8 .Calendar_monthTxt__lBWk1 {
  align-items: center;
  display: flex;
  padding-top: 5px;
}
.Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_header__GpjMU .Calendar_filter__EMCSL {
  align-items: center;
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}
.Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_header__GpjMU .Calendar_filter__EMCSL .Calendar_filterWrapper__jmNBt {
  font-size: 16px;
  font-weight: 400;
  font-style: normal;
  align-items: center;
  background-color: rgba(220, 220, 220, 0.0509803922);
  border-radius: 100px;
  color: #E0E0E0;
  cursor: pointer;
  display: flex;
  justify-content: center;
  padding: 10px 16px;
}
.Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_header__GpjMU .Calendar_filter__EMCSL .Calendar_activeFilter__IwjJS {
  background-color: #FFFFFF;
  color: #242129;
}
.Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_grid__WwfW\\+ {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
}
.Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_dayOfWeek__d0Ktr {
  text-align: center;
  margin-bottom: 24px;
}
.Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_dayOfWeekWrapper__E0Nej {
  background-color: #FFFFFF;
  border-radius: 100px;
  color: #1B1E23;
  display: inline;
  font-size: 14px;
  font-weight: 500;
  padding: 6px 12px;
}
.Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_day__UsmN\\+ {
  min-height: 217px;
}
.Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_day__UsmN\\+,
.Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_dayEmpty__wdB\\+2 {
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  padding-top: 31px;
  color: #fff;
  background: rgba(25, 3, 35, 0.65);
  padding-bottom: 31px;
  position: relative;
}
.Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_day__UsmN\\+ .Calendar_dayNum__rx9Xs,
.Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_dayEmpty__wdB\\+2 .Calendar_dayNum__rx9Xs {
  left: 10px;
  position: absolute;
  top: 10px;
}
.Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_day__UsmN\\+ .Calendar_game__Y5jI2,
.Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_dayEmpty__wdB\\+2 .Calendar_game__Y5jI2 {
  bottom: 8px;
  display: flex;
  gap: 10px;
  left: 8px;
  position: absolute;
}
.Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_day__UsmN\\+ .Calendar_game__Y5jI2 .Calendar_gameItem__p8pi0,
.Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_dayEmpty__wdB\\+2 .Calendar_game__Y5jI2 .Calendar_gameItem__p8pi0 {
  align-items: center;
  background-color: #611D14;
  border-radius: 100px;
  display: flex;
  gap: 4px;
  font-size: 13px;
  font-weight: 400;
  padding: 6px 7px;
}
.Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_day__UsmN\\+ .Calendar_game__Y5jI2 .Calendar_gameItemCS__oeAO8,
.Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_dayEmpty__wdB\\+2 .Calendar_game__Y5jI2 .Calendar_gameItemCS__oeAO8 {
  background-color: #614714;
}
.Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_day__UsmN\\+ .Calendar_game__Y5jI2 .Calendar_gameItemLol__Em77v,
.Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_dayEmpty__wdB\\+2 .Calendar_game__Y5jI2 .Calendar_gameItemLol__Em77v {
  background-color: rgba(199, 155, 59, 0.1490196078);
}
.Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_dayEmpty__wdB\\+2 {
  background-color: transparent;
  border: none;
}
.Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_today__E1aI4 {
  background: #2d083e;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  z-index: 0;
}
.Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_event__Xn0qW {
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 4px;
  padding: 4px 8px;
  background-color: rgba(0, 123, 255, 0.7);
  font-size: 12px;
  text-overflow: ellipsis;
}
.Calendar_wrapper__og-2T .Calendar_modal__xufwr {
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  right: 0;
  position: fixed;
  top: 0;
  z-index: 2;
}
.Calendar_wrapper__og-2T .Calendar_modal__xufwr .Calendar_modalWrapper__DnmUB {
  background-color: #310048;
  border-radius: 8px;
  width: 50%;
}
.Calendar_wrapper__og-2T .Calendar_modal__xufwr .Calendar_modalWrapper__DnmUB .Calendar_modalImg__8CLfD {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  height: 193px;
  width: 100%;
}
.Calendar_wrapper__og-2T .Calendar_modal__xufwr .Calendar_modalWrapper__DnmUB .Calendar_modalInfo__D\\+XEy {
  padding: 16px 20px;
}
.Calendar_wrapper__og-2T .Calendar_modal__xufwr .Calendar_modalWrapper__DnmUB .Calendar_modalInfo__D\\+XEy .Calendar_modalTitle__pZ-Mi {
  color: #FFFFFF;
  font-size: 24px;
  font-weight: 700;
}
.Calendar_wrapper__og-2T .Calendar_modal__xufwr .Calendar_modalWrapper__DnmUB .Calendar_modalInfo__D\\+XEy .Calendar_modalGame__zRFMZ {
  align-items: center;
  border-bottom: 1px solid rgba(224, 224, 224, 0.3490196078);
  display: flex;
  gap: 16px;
  margin-top: 16px;
  padding-bottom: 16px;
}
.Calendar_wrapper__og-2T .Calendar_modal__xufwr .Calendar_modalWrapper__DnmUB .Calendar_modalInfo__D\\+XEy .Calendar_modalGame__zRFMZ .Calendar_modalGameItem__pUBkb {
  align-items: center;
  background-color: #611D14;
  border-radius: 100px;
  color: #fff;
  display: flex;
  gap: 4px;
  font-size: 13px;
  font-weight: 400;
  padding: 6px 7px;
}
.Calendar_wrapper__og-2T .Calendar_modal__xufwr .Calendar_modalWrapper__DnmUB .Calendar_modalInfo__D\\+XEy .Calendar_modalGame__zRFMZ .Calendar_modalGameItemCS__pp22W {
  background-color: #614714;
}
.Calendar_wrapper__og-2T .Calendar_modal__xufwr .Calendar_modalWrapper__DnmUB .Calendar_modalInfo__D\\+XEy .Calendar_modalGame__zRFMZ .Calendar_modalGameItemLol__wrK0i {
  background-color: rgba(199, 155, 59, 0.1490196078);
}
.Calendar_wrapper__og-2T .Calendar_modal__xufwr .Calendar_modalWrapper__DnmUB .Calendar_modalInfo__D\\+XEy .Calendar_modalGame__zRFMZ .Calendar_modalCalendar__mmtwP {
  align-items: center;
  color: #FFFFFF;
  display: flex;
  font-size: 16px;
  font-weight: 500;
}
.Calendar_wrapper__og-2T .Calendar_modal__xufwr .Calendar_modalWrapper__DnmUB .Calendar_modalInfo__D\\+XEy .Calendar_modalDescription__d6bbJ {
  color: #E0E0E0;
  font-size: 16px;
  font-weight: 400;
  line-height: 150%;
  margin-top: 16px;
}
.Calendar_wrapper__og-2T .Calendar_modal__xufwr .Calendar_modalWrapper__DnmUB .Calendar_modalInfo__D\\+XEy .Calendar_modalBtns__KL8Vu {
  display: flex;
  gap: 16px;
  justify-content: end;
  margin-top: 20px;
}

@media (max-width: 1291px) {
  .Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_game__Y5jI2 .Calendar_gameItem__p8pi0 .Calendar_gameItemName__P3PRV {
    display: none;
  }
}
@media (max-width: 1100px) {
  .Calendar_wrapper__og-2T .Calendar_container__bjtjy {
    width: 90%;
  }
  .Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_header__GpjMU {
    display: flex;
    justify-content: space-between;
  }
  .Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_header__GpjMU .Calendar_emptyDiv__\\+RH68 {
    display: none;
  }
  .Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_header__GpjMU .Calendar_month__9iVd8 {
    font-size: 18px;
    gap: 6px;
  }
  .Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_header__GpjMU .Calendar_arrowWrapper__ukiXT {
    height: 24px;
    width: 24px;
  }
  .Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_header__GpjMU .Calendar_filter__EMCSL {
    justify-content: unset;
  }
  .Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_header__GpjMU .Calendar_filter__EMCSL .Calendar_filterWrapper__jmNBt {
    padding: 8px;
  }
}
@media (max-width: 700px) {
  .Calendar_wrapper__og-2T .Calendar_modal__xufwr .Calendar_modalWrapper__DnmUB {
    height: 100%;
    width: 100%;
  }
  .Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_day__UsmN\\+ {
    min-height: 157px;
  }
  .Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_day__UsmN\\+ .Calendar_game__Y5jI2 {
    gap: unset;
    justify-content: space-between;
    left: 6px;
    right: 6px;
  }
  .Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_day__UsmN\\+ .Calendar_game__Y5jI2 .Calendar_gameItem__p8pi0 {
    align-items: center;
    background-color: unset;
    display: flex;
    justify-content: center;
    padding: unset;
  }
  .Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_day__UsmN\\+ .Calendar_game__Y5jI2 .Calendar_gameItem__p8pi0 img {
    height: 8px;
    width: 8px;
  }
  .Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_event__Xn0qW {
    padding: 4px 2px;
  }
  .Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_event__Xn0qW .Calendar_eventName__NM57F {
    font-size: 6px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Tournaments/Calendar/Calendar.module.scss","webpack://./src/assets/styles/_fonts.scss"],"names":[],"mappings":"AAEA;EAME,sBAAA;EACA,4BAAA;EACA,iBAAA;EACA,oBAAA;AANF;AAQE;EACE,cAAA;EACA,UAAA;EACA,iBAAA;AANJ;AAQI;EACE,mBAAA;EACA,0DAAA;EACA,aAAA;EACA,kCAAA;EACA,oBAAA;EACA,mBAAA;AANN;AAQM;ECPJ,eAAA;EACA,gBAAA;EACA,kBAAA;EDQM,mBAAA;EACA,WAAA;EACA,aAAA;EACA,SAAA;EACA,uBAAA;AALR;AAOQ;EACE,mBAAA;EACA,0CAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,YAAA;EACA,uBAAA;EACA,WAAA;AALV;AAQQ;EACE,mBAAA;EACA,aAAA;EACA,gBAAA;AANV;AAUM;EACE,mBAAA;EACA,aAAA;EACA,SAAA;EACA,yBAAA;AARR;AAUQ;ECEN,eAAA;EACA,gBAAA;EACA,kBAAA;EDDQ,mBAAA;EACA,mDAAA;EACA,oBAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;AAPV;AAUQ;EACE,yBAAA;EACA,cAAA;AARV;AAaI;EACE,aAAA;EACA,qCAAA;AAXN;AAcI;EACE,kBAAA;EACA,mBAAA;AAZN;AAeI;EACE,yBAAA;EACA,oBAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAbN;AAgBI;EACE,iBAAA;AAdN;AAiBI;;EAEE,0CAAA;EACA,kBAAA;EAEA,iBAAA;EACA,WAAA;EACA,iCAAA;EAGA,oBAAA;EACA,kBAAA;AAlBN;AAoBM;;EACE,UAAA;EACA,kBAAA;EACA,SAAA;AAjBR;AAoBM;;EACE,WAAA;EACA,aAAA;EACA,SAAA;EACA,SAAA;EACA,kBAAA;AAjBR;AAmBQ;;EACE,mBAAA;EACA,yBAAA;EACA,oBAAA;EACA,aAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAhBV;AAmBQ;;EACE,yBAAA;AAhBV;AAmBQ;;EACE,kDAAA;AAhBV;AAqBI;EACE,6BAAA;EACA,YAAA;AAnBN;AAqBI;EACE,mBAAA;EACA,0CAAA;EACA,kBAAA;EAEA,UAAA;AApBN;AAuBI;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wCAAA;EACA,eAAA;EACA,uBAAA;AArBN;AAyBE;EACE,mBAAA;EACA,oCAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;EACA,OAAA;EACA,QAAA;EACA,eAAA;EACA,MAAA;EACA,UAAA;AAvBJ;AAyBI;EACE,yBAAA;EACA,kBAAA;EACA,UAAA;AAvBN;AAyBM;EACE,4BAAA;EACA,sBAAA;EACA,2BAAA;EACA,aAAA;EACA,WAAA;AAvBR;AA0BM;EACE,kBAAA;AAxBR;AA0BQ;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAxBV;AA2BQ;EACE,mBAAA;EACA,0DAAA;EAEA,aAAA;EACA,SAAA;EACA,gBAAA;EACA,oBAAA;AA1BV;AA6BU;EACE,mBAAA;EACA,yBAAA;EACA,oBAAA;EACA,WAAA;EACA,aAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AA3BZ;AA8BU;EACE,yBAAA;AA5BZ;AA+BU;EACE,kDAAA;AA7BZ;AAgCU;EACE,mBAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;AA9BZ;AAkCQ;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AAhCV;AAmCQ;EACE,aAAA;EACA,SAAA;EACA,oBAAA;EACA,gBAAA;AAjCV;;AAwCA;EASU;IACE,aAAA;EA7CV;AACF;AAoDA;EAGI;IACE,UAAA;EApDJ;EAsDI;IACE,aAAA;IACA,8BAAA;EApDN;EAsDM;IACE,aAAA;EApDR;EAuDM;IACE,eAAA;IACA,QAAA;EArDR;EAwDM;IACE,YAAA;IACA,WAAA;EAtDR;EAyDM;IACE,sBAAA;EAvDR;EAyDQ;IACE,YAAA;EAvDV;AACF;AA8DA;EAKM;IACE,YAAA;IACA,WAAA;EAhEN;EAsEI;IACE,iBAAA;EApEN;EAsEM;IACE,UAAA;IACA,8BAAA;IACA,SAAA;IACA,UAAA;EApER;EAsEQ;IACE,mBAAA;IACA,uBAAA;IACA,aAAA;IACA,uBAAA;IAGA,cAAA;EAtEV;EAwEU;IACE,WAAA;IACA,UAAA;EAtEZ;EA8EI;IACE,gBAAA;EA5EN;EA8EM;IACE,cAAA;EA5ER;AACF","sourcesContent":["@import '../../../assets/styles/global.scss';\n\n.wrapper {\n  // main-season down\n  // background-image: url('../../../assets/images/tournaments.jpg');\n  \n  //Winter-season down\n  // background-image: url('../../../assets/images/tournaments-winter_new.jpg');\n  background-size: cover;\n  background-repeat: no-repeat;\n  margin-top: 110px;\n  padding-bottom: 80px;\n\n  .container {\n    margin: 0 auto;\n    width: 80%;\n    padding-top: 30px;\n\n    .header {\n      align-items: center;\n      border-bottom: 1px solid #E0E0E059;\n      display: grid;\n      grid-template-columns: 1fr 1fr 1fr;\n      padding-bottom: 31px;\n      margin-bottom: 24px;\n\n      .month {\n        @include subtitle1b;\n\n        align-items: center;\n        color: #fff;\n        display: flex;\n        gap: 20px;\n        justify-content: center;\n\n        .arrowWrapper {\n          align-items: center;\n          background-color: #FAF9F833;\n          border-radius: 8px;\n          cursor: pointer;\n          display: flex;\n          height: 32px;\n          justify-content: center;\n          width: 32px;\n        }\n\n        .monthTxt {\n          align-items: center;\n          display: flex;\n          padding-top: 5px;\n        }\n      }\n\n      .filter {\n        align-items: center;\n        display: flex;\n        gap: 12px;\n        justify-content: flex-end;\n\n        .filterWrapper {\n          @include body1;\n\n          align-items: center;\n          background-color: #DCDCDC0D;\n          border-radius: 100px;\n          color: #E0E0E0;\n          cursor: pointer;\n          display: flex;\n          justify-content: center;\n          padding: 10px 16px;\n        }\n\n        .activeFilter {\n          background-color: #FFFFFF;\n          color: #242129;\n        }\n      }\n    }\n\n    .grid {\n      display: grid;\n      grid-template-columns: repeat(7, 1fr);\n    }\n\n    .dayOfWeek {\n      text-align: center;\n      margin-bottom: 24px;\n    }\n\n    .dayOfWeekWrapper {\n      background-color: #FFFFFF;\n      border-radius: 100px;\n      color: #1B1E23;\n      display: inline;\n      font-size: 14px;\n      font-weight: 500;\n      padding: 6px 12px;\n    }\n\n    .day {\n      min-height: 217px;\n    }\n\n    .day,\n    .dayEmpty {\n      border: 1px solid rgba(255, 255, 255, 0.1);\n      border-radius: 8px;\n      // padding: 10px;\n      padding-top: 31px;\n      color: #fff;\n      background: rgba(25, 3, 35, 0.65);\n      \n      // height: 217px;\n      padding-bottom: 31px;\n      position: relative;\n\n      .dayNum {\n        left: 10px;\n        position: absolute;\n        top: 10px;\n      }\n\n      .game {\n        bottom: 8px;\n        display: flex;\n        gap: 10px;\n        left: 8px;\n        position: absolute;\n\n        .gameItem {\n          align-items: center;\n          background-color: #611D14;\n          border-radius: 100px;\n          display: flex;\n          gap: 4px;\n          font-size: 13px;\n          font-weight: 400;\n          padding: 6px 7px;\n        }\n\n        .gameItemCS {\n          background-color: #614714;\n        }\n\n        .gameItemLol {\n          background-color: #C79B3B26;\n        }\n      }\n    }\n\n    .dayEmpty {\n      background-color: transparent;\n      border: none;\n    }\n    .today {\n      background: #2d083e;\n      border: 1px solid rgba(255, 255, 255, 0.3);\n      border-radius: 8px;\n      // transform: scale(1.05);\n      z-index: 0;\n    }\n\n    .event {\n      cursor: pointer;\n      font-size: 13px;\n      font-weight: 500;\n      margin-bottom: 4px;\n      padding: 4px 8px;\n      background-color: rgba(0, 123, 255, 0.7);\n      font-size: 12px;\n      text-overflow: ellipsis;\n    }\n  }\n\n  .modal {\n    align-items: center;\n    background-color: rgba(0, 0, 0, 0.5);\n    bottom: 0;\n    display: flex;\n    justify-content: center;\n    left: 0;\n    right: 0;\n    position: fixed;\n    top: 0;\n    z-index: 2;\n\n    .modalWrapper {\n      background-color: #310048;\n      border-radius: 8px;\n      width: 50%;\n\n      .modalImg {\n        background-repeat: no-repeat;\n        background-size: cover;\n        background-position: center;\n        height: 193px;\n        width: 100%;\n      }\n\n      .modalInfo {\n        padding: 16px 20px;\n\n        .modalTitle {\n          color: #FFFFFF;\n          font-size: 24px;\n          font-weight: 700;\n        }\n\n        .modalGame {\n          align-items: center;\n          border-bottom: 1px solid #E0E0E059;\n\n          display: flex;\n          gap: 16px;\n          margin-top: 16px;\n          padding-bottom: 16px;\n\n\n          .modalGameItem {\n            align-items: center;\n            background-color: #611D14;\n            border-radius: 100px;\n            color: #fff;\n            display: flex;\n            gap: 4px;\n            font-size: 13px;\n            font-weight: 400;\n            padding: 6px 7px;\n          }\n\n          .modalGameItemCS {\n            background-color: #614714;\n          }\n\n          .modalGameItemLol {\n            background-color: #C79B3B26;\n          }\n\n          .modalCalendar {\n            align-items: center;\n            color: #FFFFFF;\n            display: flex;\n            font-size: 16px;\n            font-weight: 500;\n          }\n        }\n\n        .modalDescription {\n          color: #E0E0E0;\n          font-size: 16px;\n          font-weight: 400;\n          line-height: 150%;\n          margin-top: 16px;\n        }\n\n        .modalBtns {\n          display: flex;\n          gap: 16px;\n          justify-content: end;\n          margin-top: 20px;\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 1291px) {\n  .wrapper {\n\n    .container {\n\n      .game {\n\n        .gameItem {\n\n          .gameItemName {\n            display: none;\n          }\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 1100px) {\n  .wrapper {\n\n    .container {\n      width: 90%;\n\n      .header {\n        display: flex;\n        justify-content: space-between;\n\n        .emptyDiv {\n          display: none;\n        }\n\n        .month {\n          font-size: 18px;\n          gap: 6px;\n        }\n\n        .arrowWrapper {\n          height: 24px;\n          width: 24px;\n        }\n\n        .filter {\n          justify-content: unset;\n\n          .filterWrapper {\n            padding: 8px;\n          }\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 700px) {\n  .wrapper {\n\n    .modal {\n\n      .modalWrapper {\n        height: 100%;\n        width: 100%;\n      }\n    }\n\n    .container {\n\n      .day {\n        min-height: 157px;\n        \n        .game {\n          gap: unset;\n          justify-content: space-between;\n          left: 6px;\n          right: 6px;\n\n          .gameItem {\n            align-items: center;\n            background-color: unset;\n            display: flex;\n            justify-content: center;\n            // height: 16px;\n            // width: 16px;\n            padding: unset;\n\n            img {\n              height: 8px;\n              width: 8px;\n            }\n          }\n        }\n      }\n\n\n\n      .event {\n        padding: 4px 2px;\n\n        .eventName {\n          font-size: 6px;\n        }\n      }\n    }\n  }\n}","@mixin h1 {\n  font-size: 64px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h2 {\n  font-size: 48px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h3 {\n  font-size: 32px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle1b {\n  font-size: 24px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle2m {\n  font-size: 24px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle3b {\n  font-size: 20px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle4m {\n  font-size: 20px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle5 {\n  font-size: 20px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin subtitle6m {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle7m {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin body1 {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin body2 {\n  font-size: 14px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin buttonlarge {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonmedium {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonsmall {\n  font-size: 13px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin input {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin helper {\n  font-size: 12px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin tableinput {\n  font-size: 13px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `Calendar_wrapper__og-2T`,
	"container": `Calendar_container__bjtjy`,
	"header": `Calendar_header__GpjMU`,
	"month": `Calendar_month__9iVd8`,
	"arrowWrapper": `Calendar_arrowWrapper__ukiXT`,
	"monthTxt": `Calendar_monthTxt__lBWk1`,
	"filter": `Calendar_filter__EMCSL`,
	"filterWrapper": `Calendar_filterWrapper__jmNBt`,
	"activeFilter": `Calendar_activeFilter__IwjJS`,
	"grid": `Calendar_grid__WwfW+`,
	"dayOfWeek": `Calendar_dayOfWeek__d0Ktr`,
	"dayOfWeekWrapper": `Calendar_dayOfWeekWrapper__E0Nej`,
	"day": `Calendar_day__UsmN+`,
	"dayEmpty": `Calendar_dayEmpty__wdB+2`,
	"dayNum": `Calendar_dayNum__rx9Xs`,
	"game": `Calendar_game__Y5jI2`,
	"gameItem": `Calendar_gameItem__p8pi0`,
	"gameItemCS": `Calendar_gameItemCS__oeAO8`,
	"gameItemLol": `Calendar_gameItemLol__Em77v`,
	"today": `Calendar_today__E1aI4`,
	"event": `Calendar_event__Xn0qW`,
	"modal": `Calendar_modal__xufwr`,
	"modalWrapper": `Calendar_modalWrapper__DnmUB`,
	"modalImg": `Calendar_modalImg__8CLfD`,
	"modalInfo": `Calendar_modalInfo__D+XEy`,
	"modalTitle": `Calendar_modalTitle__pZ-Mi`,
	"modalGame": `Calendar_modalGame__zRFMZ`,
	"modalGameItem": `Calendar_modalGameItem__pUBkb`,
	"modalGameItemCS": `Calendar_modalGameItemCS__pp22W`,
	"modalGameItemLol": `Calendar_modalGameItemLol__wrK0i`,
	"modalCalendar": `Calendar_modalCalendar__mmtwP`,
	"modalDescription": `Calendar_modalDescription__d6bbJ`,
	"modalBtns": `Calendar_modalBtns__KL8Vu`,
	"gameItemName": `Calendar_gameItemName__P3PRV`,
	"emptyDiv": `Calendar_emptyDiv__+RH68`,
	"eventName": `Calendar_eventName__NM57F`
};
export default ___CSS_LOADER_EXPORT___;
